import { Button, List, ListItem, ListItemIcon, Stack, Typography } from '@mui/material'
import { WarningCircle as WarningCircleIcon } from '@phosphor-icons/react'
import { useCallback, useMemo, useState } from 'react'

import { EncapsulatedTheme } from '@salsita-ai/platform-project-sdk/react'
import { Dialog } from '@salsita-ai/platform-project-sdk/ui'

import { metalworksTheme } from '../metalworksTheme'

const sessionStorageKey = 'metalworks-configurator-disclaimer-seen-count'

const maxDisplayCount = phoenix.runtimeConfig.DISCLAIMER_DISPLAY_COUNT

export const Disclaimer = () => {
  const displayedCount = useMemo(() => {
    return parseInt(localStorage.getItem(sessionStorageKey) ?? '') || 0
  }, [])

  const [isOpen, setIsOpen] = useState(displayedCount < maxDisplayCount)

  const handleClose = useCallback(() => {
    setIsOpen(false)
    localStorage.setItem(sessionStorageKey, (displayedCount + 1).toString())
  }, [displayedCount])

  if (!isOpen) {
    return null
  }

  return (
    <EncapsulatedTheme themeOptions={metalworksTheme}>
      <Dialog.Root variant="static" sx={{ maxWidth: 800, textAlign: 'center' }}>
        <Dialog.ContentLayout
          controlsPosition="end"
          body={
            <>
              <Stack direction="column">
                <Typography variant="h4" sx={{ mt: 4, mb: 4 }}>
                  Welcome to Metalworks configurator
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <WarningCircleIcon size={30} />
                    </ListItemIcon>
                    <Typography variant="body1">
                      This 3D configurator is a quoting tool only – it does not place or process orders.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <WarningCircleIcon size={30} />
                    </ListItemIcon>
                    <Typography variant="body1">All purchases must be completed via your Daveweb cart.</Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <WarningCircleIcon size={30} />
                    </ListItemIcon>
                    <Typography variant="body1">
                      Prices shown are indicative and may be subject to additional surcharges.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <WarningCircleIcon size={30} />
                    </ListItemIcon>
                    <Typography variant="body1">
                      Final pricing, including applicable fees, is available in your Daveweb cart.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <WarningCircleIcon size={30} />
                    </ListItemIcon>
                    <Typography variant="body1">
                      Standard lead times are approximately 10 business days, plus shipping.
                    </Typography>
                  </ListItem>
                </List>
              </Stack>
            </>
          }
          controls={
            <Button variant="contained" onClick={handleClose}>
              I understand
            </Button>
          }
        />
      </Dialog.Root>
    </EncapsulatedTheme>
  )
}
